<template>
	<el-tiptap v-model="content" :extensions="extensions" />
</template>

<script>
import {
	// necessary extensions
	Doc,
	Text,
	Paragraph,
	FontSize,
	LineHeight,
	Heading,
	Bold,
	Underline,
	Italic,
	Strike,
	Link,
	TextAlign,
	ListItem,
	BulletList,
	OrderedList,
	TextColor,
	TextHighlight,
	Indent,
	HardBreak,
	HorizontalRule,
	// Fullscreen,
	History,
	FormatClear,
} from 'element-tiptap';
export default {
	props: {
		value: String,
		editorId: [String, Number] // stavo provando a prevenire l'uso del tasto Invio per i ritorni a capo ed usare invece Ctrl + Invio. Questo perchè ho allineato a destra il testo usando flex box e se uso Invio si creano tanti paragrafi ed il testo si dispone male
	},
	
	data() {
		return {
			extensions: [
				new Doc(),
				new Text(),
				new Paragraph(),
				new FontSize(),
				new LineHeight(),
				new Heading({ level: 5 }),
				new Bold({ bubble: false }), // render command-button in bubble menu.
				new Underline({ bubble: false, menubar: true }), // render command-button in bubble menu but not in menubar.
				new Italic(),
				new Strike(),
				new Link({ bubble: false }),
				new TextAlign(),
				new ListItem(),
				new BulletList(),
				new OrderedList(),
				new TextColor(),
				new TextHighlight(),
				// new Indent(),
				new HardBreak(),
				new HorizontalRule({ bubble: false }),
				// new Fullscreen(),
				new FormatClear(),
				new History(),
			],
		}
	},
	
	computed: {
		content: {
			get() {
				return this.value;
			},
			set(content) {
				this.$emit('input', content)
			}
		}
	},
	
	mounted() {
		// console.log(document.getElementById(this.editorId))
		// document.getElementById(this.editorId).addEventListener('keypress', (
		// 	function(event){
		// 		console.log(event.key)
		// 		if (event.key == '13') {
		// 			event.preventDefault();
		// 			console.log('prevent enter')
		// 		}
		// 	}));
	},
	
	methods: {
	
	}
}
</script>

<style>
.el-tooltip__popper {
	font-family: "Roboto", sans-serif;
	letter-spacing: 1px;
	font-weight: 500;
}
</style>